module.exports = __webpack_public_path__ + "img/bay-hotel-4.92f79cfb.jpg";